import React from 'react';
import { DollarSign } from 'lucide-react';

const RevenueBreakdown = ({ revenueAnalytics = {}, overview = {} }) => {
  // Helper function to format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
    return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Revenue Breakdown</h2>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div>
            <p className="text-sm text-gray-600">Total Revenue</p>
            <p className="text-xl font-bold text-gray-900 mt-1">
              {formatCurrency(revenueAnalytics.total_revenue || overview.total_revenue || 0)}
            </p>
          </div>
          <DollarSign className="w-8 h-8 text-green-600" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Platform Fees</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.platform_fees || overview.platform_fees || 0)}
            </p>
          </div>
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Vendor Payouts</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.vendor_payouts || 0)}
            </p>
          </div>
        </div>
        {revenueAnalytics.average_booking_value && (
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Average Booking Value</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.average_booking_value)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueBreakdown;

